import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17f21925"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-flex" }
const _hoisted_2 = ["href", "aria-label"]
const _hoisted_3 = {
  key: 1,
  class: "header__right"
}

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useScreenSize } from '@/composition/useScreenSize';
import { loginUser as handleLogin } from '@/services/userActions';
import { LoggedUser } from '@/types';
import { companyWebsiteLink } from '@/utils/constTemplates';
import AppLogo from '@/components/AppLogo.vue';
import CleanButton from '@/components/CleanButton.vue';
import TransitionFade from '@/components/TransitionFade.vue';
import HeaderNavMobile from '@/components/Header/Nav/Mobile.vue';
import HeaderNavDesktop from '@/components/Header/Nav/Desktop.vue';
import UserProfile from '@/components/Header/UserProfile.vue';
import LangSwitcher from '@/components/Header/LangSwitcher.vue';
import IconLogin from '@/components/icons/Menu/Login.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const { t } = useI18n();
const { isMobileScreen } = useScreenSize();

const userData = computed<LoggedUser>(() => store.state.UserData.user);
const isDisabledLogBtn = ref(false);
const showLoader = computed(() => store.getters['Common/showLoader']);

const HeaderNav = computed(
  () => (isMobileScreen.value ? HeaderNavMobile : HeaderNavDesktop)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(['header', { mobile: _unref(isMobileScreen) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: _unref(companyWebsiteLink),
        class: "header__logo-link",
        target: "_blank",
        "aria-label": _unref(t)('vrLabs')
      }, [
        _createVNode(AppLogo)
      ], 8, _hoisted_2),
      _createVNode(TransitionFade, null, {
        default: _withCtx(() => [
          _createVNode(_unref(HeaderNav), { class: "header__nav" })
        ]),
        _: 1
      }),
      (userData.value)
        ? (_openBlock(), _createBlock(UserProfile, {
            key: 0,
            onLockLogin: _cache[0] || (_cache[0] = ($event: any) => (isDisabledLogBtn.value = true))
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(CleanButton, {
              class: "header__login nav-link__animated-bg",
              disabled: isDisabledLogBtn.value || showLoader.value,
              onClick: _unref(handleLogin)
            }, {
              default: _withCtx(() => [
                _createVNode(IconLogin, {
                  class: "header__login-icon",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", {
                  class: _normalizeClass({ 'visually-hidden': _unref(isMobileScreen) })
                }, _toDisplayString(_unref(t)("menus.login")), 3)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(LangSwitcher)
          ]))
    ])
  ], 2))
}
}

})